import { Id } from "src/utils/types";
import { request } from ".";

export type CollaboratorNotification = {
  collaborator_notification_id: number;
  id_colaborador: number;
  id_empresa: number;
  nome_colaborador?: string;
  nome_empresa?: string;
  id_remetente?: number;
  nome_remetente?: string;
  email_remetente?: string;
  notificacao_de_plataforma?: boolean;
  lida: boolean;
  criado_em: string;
  publicado_em?: string;
  lida_em?: string;
  tipo?: string;
  mensagem: string;
  subject?: string;
  prioridade?: string;
  assunto?: string;
};

export enum CollaboratorNotificationTarget {
  ALL_COLLABORATORS = "ALL_COLLABORATORS",
  COMPANY_COLLABORATORS = "COMPANY_COLLABORATORS",
  ONE_COLLABORATOR = "ONE_COLLABORATOR",
}

export type CreateCollaboratorNotificationPayload = {
  target: CollaboratorNotificationTarget;
  company_id?: Id;
  collaborator_id?: Id | null;
  subject: string;
  message: string;
  type?: string;
  priority?: string;
};

export type CollaboratorNotificationCount = {
  unread: number;
};

export const getCollaboratorNotifications = async (
  page: number,
  channel: string = "PORTAL_COLLABORATOR",
): Promise<CollaboratorNotification[]> => {
  const response = await request.get<CollaboratorNotification[]>(
    `/collaborators/notifications`,
    {
      params: {
        page,
        channel,
      },
    },
  );

  if (!response) {
    return [];
  }

  return response.data;
};

export const getCollaboratorUnreadNotificationsCount = async (
  channel: string = "PORTAL_COLLABORATOR",
): Promise<number> => {
  const response = await request.get<CollaboratorNotificationCount>(
    `/collaborators/notifications/unread-count`,
    {
      params: {
        channel,
      },
    },
  );

  if (!response) {
    return 0;
  }

  return response.data.unread ?? 0;
};

export const markCollaboratorNotificationAsRead = async (id: Id): Promise<void> => {
  await request.post(`/collaborators/notifications/${id}/mark-as-read`);
};

export async function createCollaboratorNotification(
  payload: CreateCollaboratorNotificationPayload,
): Promise<void> {
  const { type, priority, subject, message, ...rest } = payload;
  const resolvedType = type ?? "FRONTEND";
  const resolvedPriority = priority ?? "NORMAL";
  const resolvedSubject = subject ?? "";
  const resolvedMessage = message ?? "";

  await request.post(`/portal/collaborators/notifications`, {
    ...rest,
    type: resolvedType,
    priority: resolvedPriority,
    subject: resolvedSubject,
    message: resolvedMessage,
    assunto: resolvedSubject,
    mensagem: resolvedMessage,
    prioridade: resolvedPriority,
  });
}
